// extracted by mini-css-extract-plugin
export default {"dropdown":"Signup_dropdown__8Vt1G","selected":"Signup_selected__+0z5m","notSelected":"Signup_notSelected__9bZO2","disabled":"Signup_disabled__VOr07"};